import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function TermsPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="container mx-auto px-4">
        <button
          onClick={() => navigate("/")}
          className="mb-6 flex items-center text-sm text-gray-600 hover:text-gray-900"
        >
          <ArrowLeft className="mr-1 size-4" />
          Back
        </button>

        <div className="mx-auto max-w-3xl rounded-xl border bg-white p-8 shadow-sm">
          <h1 className="mb-6 text-2xl font-bold text-gray-900">
            User Participant Agreement
          </h1>

          <div className="prose prose-sm">
            <p className="mb-4">
              You have agreed to participate in Vincer's pilot program, which
              assesses the effectiveness of using occupational peers as mentors
              to support sales professionals with work-related stress and
              burnout. PLEASE READ THIS PARTICIPANT AGREEMENT ("TERMS")
              CAREFULLY. THESE TERMS ARE A LEGAL CONTRACT BETWEEN YOU AND
              VINCER.
            </p>

            <p className="mb-4">
              Vincer's pilot program is not a medical service and is not
              intended for serious mental health conditions, medical advice, or
              crisis situations. Vincer's mentors are not licensed, certified,
              or trained in mental health and are not healthcare providers.
            </p>

            <p className="mb-4">
              If you feel you are in a crisis or have a serious mental health
              condition, please contact your healthcare provider, call #911, or
              call the free Suicide Prevention Lifeline #988. If a mentor feels
              you are in imminent danger to yourself or others, your mentor has
              the right to inform Vincer under mandatory reporting protocols
              based on state and local governments.
            </p>

            <h2 className="mb-4 mt-6 text-xl font-semibold">
              What We Ask of You
            </h2>
            <ul className="mb-4 list-disc space-y-2 pl-6">
              <li>
                You agree to have your camera on during video sessions to
                provide the best experience for you and your mentor.
              </li>
              <li>
                Our sessions are a safe space to share and build trust between
                both parties. Your mentor has agreed in writing to maintain your
                privacy and must keep confidential all information you share
                during sessions. You agree to keep the identity, stories, and
                information your mentor shares confidential.
              </li>
              <li>
                You will avoid sharing data, facts, client information, or any
                other information that could breach any confidentiality
                agreement you may have with your employer, a prospective client,
                or your existing client.
              </li>
              <li>
                You will engage your mentor in a considerate and professional
                way, avoiding profanity, yelling, or displaying aggression or
                hostility.
              </li>
              <li>
                Your mentor will see your first name, occupation, and a brief
                description of why you're seeking support. You can share
                additional information with your mentor, such as last name,
                employer name, location, family details, etc. You agree not to
                contact your mentor outside of the Vincer platform.
              </li>
              <li>
                You will not sell your product/services, solicit any employment,
                or request favors or services of mentors outside the Vincer
                pilot's scope.
              </li>
              <li>
                We would like you to give us feedback on the program, your
                mentor, and the overall experience to learn how to improve the
                service for the sales community. You will receive a cash payment
                of $100 for completing any feedback surveys during the pilot.
                You grant Vincer a perpetual license to use any feedback you
                provide.
              </li>
            </ul>

            <h2 className="mb-4 mt-6 text-xl font-semibold">Confidentiality</h2>
            <p className="mb-4">
              Vincer will use reasonable efforts to meet industry standards of
              confidentiality, privacy, and security, including:
            </p>
            <ul className="mb-4 list-disc space-y-2 pl-6">
              <li>
                Your Vincer profile information, information you share in
                sessions, mentor advice shared with you, or any information you
                send to our customer support chat is never shared outside of the
                platform.
              </li>
              <li>
                We do not sell information you share with us to third parties.
              </li>
              <li>
                We do not share the information you share with your mentor with
                your employer or any third party.
              </li>
              <li>
                We do not share the information you share with us with other
                mentors or participants on the platform.
              </li>
              <li>
                Your sessions are recorded for safety and quality assurance
                purposes and kept on file for 24 months.
              </li>
              <li>You acknowledge that Vincer is not subject to HIPAA.</li>
            </ul>

            <h2 className="mb-4 mt-6 text-xl font-semibold">Other Topics</h2>
            <p className="mb-4 uppercase">
              THE SERVICES ARE PROVIDED ON AN "AS-IS" AND "AS AVAILABLE" BASIS,
              WITH ALL FAULTS AND NO GUARANTEES REGARDING OUTCOMES OR
              PERFORMANCE. WE HAVE NO LIABILITY FOR RESULTS IN CONNECTION WITH
              THE SERVICES OR THE ACTIONS OR OMISSIONS OF ANY MENTOR.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
